import { Button } from "@/components/ui/button";
import MainContainer from "@/Elements/MainContainer";
import Navbar from "@/Elements/Navbar";
import Arc from "@/lib/Arc";
import { useAuth } from "@/Services/AuthContext";
import { ChevronLeft } from "lucide-react";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

function WalkInHistoryScreen() {
	const navigate = useNavigate();
	const { user, isAuthenticated, loading, login, logout } = useAuth();
	const [walkins, setWalkins] = useState([]);
	useEffect(() => {
		Arc().read('data', 'reader', [
			"entity=walkins",
			`where=[[guardian_uid,${user.uid}]]`
		]).then(res => setWalkins(res.result)).catch(console.error)
	}, [])


	return (
		<>
			<Navbar></Navbar>

			<MainContainer>
				<Button variant="ghost" onClick={() => { navigate('/home') }}>
					<ChevronLeft />
					Back to Home
				</Button>
				<h1 className='text-3xl md:text-4xl lg:text-5xl font-extrabold drop-shadow-lg mt-2'>
					Your Visit History
				</h1>
				<p className='mt-1'>
					True Async PHP is Here! First Alpha Release Unleashes a New Era for High-Performance Apps.
				</p>



			</MainContainer>
		</>
	);
}
export default WalkInHistoryScreen;